export default {
      id: "ic_change_player-usage",
      viewBox: "0 0 17 16",
      url: "/" + "images/icons.3.109.2.svg#ic_change_player-usage",
      toString: function () {
        return this.url;
      }
    }